import React, { useState } from 'react';
import PropTypes from 'prop-types';

import PasswordInput from './password-input';

import IString from '../../i-string';
import InfoToggle from '../../info-toggle';

import { translate } from '../../../i18n/localize';

import classnames from '../../../util/classnames';

function PasswordWithInfo(props) {
  const { onChange, open = false } = props;

  const [showInfo, setShowInfo] = useState(false);

  return (
    <>
      <div className='relativeFrame'>
        <PasswordInput onChangePassword={onChange} />

        <div className='actionBar inline afterInput'>
          <InfoToggle toggled={showInfo || open} onToggle={setShowInfo} label={translate('password.infoLabel')} />
        </div>
      </div>

      { (open || showInfo) && 
        <div className='toggleableInfo'>
          <p>
            <strong><IString stringKey='password.strongPassword' className={classnames({ error: open })} /></strong>
          </p>
          <ul>
            <li><IString stringKey='password.useUpperLowerLetters' /></li>
            <li><IString stringKey='password.useNumbers' /></li>
            <li><IString stringKey='password.useSpecialCharacters' /></li>
            <li><IString stringKey='password.useLonger' /></li>
          </ul>
        </div> }
    </>
  );
}

PasswordWithInfo.propTypes = {
  onChange: PropTypes.func,
  open: PropTypes.bool
};

export default PasswordWithInfo;
